import React, { useState, useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './i18n/LanguageContext';
import TopNav from './components/TopNav';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Models from './components/Models';
import Contact from './components/Contact';
import Footer from './components/Footer';

// 检测页面是否被嵌入到 iframe 中(跨域安全:仅比较引用,不访问 top 的属性)
const isEmbedded = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true; // 跨域访问受限时,说明一定在 iframe 里
  }
})();

function App() {
  const [tweaks] = useState({
    accentHue: 145,
    scanlines: 35,
    density: "comfortable",
    monoFont: "JetBrains Mono",
    showCursor: true
  });


  useEffect(() => {
    const r = document.documentElement;
    r.style.setProperty("--accent-h", tweaks.accentHue);
    r.style.setProperty("--scan-alpha", (tweaks.scanlines / 100).toFixed(3));
    r.style.setProperty("--mono", `"${tweaks.monoFont}", "JetBrains Mono", "Fira Code", ui-monospace, monospace`);
    r.dataset.density = tweaks.density;
  }, [tweaks]);

  return (
    <LanguageProvider>
      <div className="vignette" aria-hidden="true" />
      {!isEmbedded && <TopNav />}
      <main>
        <Hero showCursor={tweaks.showCursor} />
        <Marquee />
        <Models />
        <Contact />
      </main>
      <Footer />
    </LanguageProvider>
  );
}

export default App;
